import {
    Directive,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
} from '@angular/core';

// it fixes the issue only the first tab (products)
const noTransformValue = 'translate3d(0%, 0px, 0px)';

@Directive({
    selector: '[modalsOverlayFix]',
    standalone: false
})
export class ModalsOverlayFixDirective implements OnInit, OnDestroy {
    private mutationObserver: MutationObserver;

    constructor(private el: ElementRef) {
        this.mutationObserver = new MutationObserver(
            (mutations: MutationRecord[]) => {
                mutations.forEach((mutation: MutationRecord) => {
                    this.onStyleChange(mutation.target as HTMLElement);
                });
            }
        );
    }

    @HostListener('touchstart') onTouchStart() {
        const style = this.el.nativeElement.style;
        if (style.transform === 'unset') {
            style.transform = noTransformValue;
        }
    }

    onStyleChange(elem: HTMLElement) {
        const transform = elem.style.transform;
        if (transform === noTransformValue) {
            elem.style.transform = 'unset';
        }
    }

    ngOnInit() {
        this.mutationObserver.observe(this.el.nativeElement, {
            attributes: true,
            attributeFilter: ['style'],
        });
    }

    ngOnDestroy() {
        this.mutationObserver.disconnect();
    }
}
